import { useAuth0 } from '@auth0/auth0-react'
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'

import { Button, Icon, RadialIcon } from '@sparkai/ui'

import { useLogout } from '../hooks/useLogout'

type ErrorMessageProps = {
  errorType: 'failed-profile-load' | 'failed-token-load' | 'unknown'
}

export function ErrorMessage({ errorType }: ErrorMessageProps) {
  const logout = useLogout()
  const { isAuthenticated } = useAuth0()
  return (
    <div className='flex h-screen flex-col'>
      <div className='flex h-12 items-center border-b border-b-gray-200 px-4 py-5'>
        <Icon name='logo-colorful' className='ml-2' />
      </div>
      <div className='flex w-full flex-1 flex-col items-center justify-center bg-gray-50'>
        <div className='flex flex-col items-center justify-center gap-6'>
          <RadialIcon variant='gray' icon='close-colorful-circle' />
          <h1 className='font-inter text-2xl font-medium text-gray-700'>
            An error occurred during authentication
          </h1>

          <p className='max-w-2xl text-center text-base font-normal text-gray-500'>
            You can try reloading the page {isAuthenticated ? 'or logging out' : ''}, but if the error
            persists, please reach out to SparkAI support for assistance.
          </p>
          <p className='font-mono text-sm text-gray-400'>ERROR CODE: {errorType}</p>
          <div className='flex gap-3'>
            <Button variant='white' className='flex gap-3' onClick={() => window.location.reload()}>
              <p className='text-sm font-medium'>Reload</p>
            </Button>

            {isAuthenticated ? (
              <Button variant='white' className='flex gap-3' onClick={() => logout()}>
                <p className='text-sm font-medium'>Logout</p>
                <ArrowRightOnRectangleIcon className='h-5 w-5 text-gray-500' aria-hidden='true' />
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
